import { registerTheme } from './registry';
import { defaultTheme } from './themes/default';
import { aham37Theme } from './themes/aham37';

// Register all known themes
registerTheme(defaultTheme);
registerTheme(aham37Theme);

// Re-exports for consuming code
export { getTheme, getAllThemeIds } from './registry';
export { registerTheme } from './registry';
export { defaultTheme } from './themes/default';
export type { ThemeDefinition, ThemeAssets } from './types';
